export default {
  inputNotes: [],
};
